import { render, staticRenderFns } from "./configProgram.vue?vue&type=template&id=ab94d0ea&scoped=true"
import script from "./configProgram.vue?vue&type=script&lang=js"
export * from "./configProgram.vue?vue&type=script&lang=js"
import style0 from "./configProgram.vue?vue&type=style&index=0&id=ab94d0ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab94d0ea",
  null
  
)

export default component.exports